<script lang="ts" setup>
import type { TextCard as TextCardData } from '~/components/TextCard.vue'
import TextCard from '~/components/TextCard.vue'
import TextCardHeader from '~/components/TextCardHeader.vue'

defineProps<{ textCards: TextCardData[] }>()
</script>

<template>
  <div class="text-cards-block">
    <section
      v-for="card in textCards"
      :key="card.title"
    >
      <TextCard
        class="desktop"
        :title="card.title"
        :highlights="card.highlights"
        :cta="card.cta"
      />
      <NuxtLink
        class="mobile"
        :to="$url(card.cta.url)"
      >
        <TextCardHeader
          :title="card.title"
          show-chevron
        />
      </NuxtLink>
    </section>
  </div>
</template>

<style scoped>
.text-cards-block {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-s);

  @media (min-width: 768px) {
    gap: var(--spacing-m);
    grid-template-columns: 1fr;
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }

  .desktop {
    display: none;
    @media (min-width: 768px) {
      display: flex;
    }
  }

  .mobile {
    @media (min-width: 768px) {
      display: none;
    }
  }
}
</style>
